// extracted by mini-css-extract-plugin
module.exports = {"info":"_1ONDJH","atfInfo":"_2vWb4y","breakWords":"_2czKtE","modalWrapper":"_1az1YE"};